<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 12H10M20 17H6M20 7H4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
